<button class="btn border" (click)="setVideo(1)">Registrera Uppdrag och Ämbeten</button>
<button class="btn border" (click)="reloadPage()">Visa video</button>
<video id="vid1" class="azuremediaplayer amp-default-skin" controls width="640" height="400" poster="../../../../assets/stavar_medium.jpg" data-setup='{"nativeControlsForTouch": false}'>
  <source src="https://ofmembersmedia-euwe.streaming.media.azure.net/07e7a33f-65db-4613-a6f1-44c3b2a41d2b/SVOMS - Registrera uppdrag och Ä.ism/manifest" />
  <p class="amp-no-js">
    To view this video please enable JavaScript, and consider upgrading to a web browser that supports HTML5 video
  </p>
</video>